
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCameraIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 32,
  viewBox: "0 0 38 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.45 1-.131.007c-.39.039-.745.25-.965.58L10.711 5.56l-5.36.001A4.353 4.353 0 0 0 1 9.92v16.72A4.355 4.355 0 0 0 5.35 31h27.3A4.355 4.355 0 0 0 37 26.64V9.92l-.004-.19a4.354 4.354 0 0 0-4.346-4.17h-5.362l-2.642-3.973A1.32 1.32 0 0 0 23.55 1h-9.1zm.705 2.64h7.69l2.642 3.972c.245.367.656.588 1.096.588h6.067c.947 0 1.716.77 1.716 1.72v16.72c0 .95-.769 1.72-1.716 1.72H5.35c-.947 0-1.716-.77-1.716-1.72V9.92c0-.95.769-1.72 1.716-1.72h6.067l.13-.007c.39-.039.746-.25.966-.58l2.642-3.973z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 10a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zm0 2.676a4.824 4.824 0 1 1 0 9.649 4.824 4.824 0 0 1 0-9.649z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"38\" height=\"32\" viewBox=\"0 0 38 32\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\".2\">\r\n            <g>\r\n                <g>\r\n                    <path d=\"M13.45 0l-.131.007c-.39.039-.745.25-.965.58L9.711 4.56l-5.36.001C1.947 4.56 0 6.512 0 8.92v16.72C0 28.048 1.948 30 4.35 30h27.3c2.402 0 4.35-1.952 4.35-4.36V8.92l-.004-.19c-.099-2.32-2.007-4.17-4.346-4.17h-5.362L23.646.587C23.4.22 22.99 0 22.55 0h-9.1zm.705 2.64h7.69l2.642 3.972c.245.367.656.588 1.096.588h6.067c.947 0 1.716.77 1.716 1.72v16.72c0 .95-.769 1.72-1.716 1.72H4.35c-.947 0-1.716-.77-1.716-1.72V8.92c0-.95.769-1.72 1.716-1.72h6.067l.13-.007c.39-.039.746-.25.966-.58l2.642-3.973z\" transform=\"translate(-251 -362) translate(36 350) translate(216 13)\"/>\r\n                    <path d=\"M17.5 9c-4.142 0-7.5 3.358-7.5 7.5 0 4.142 3.358 7.5 7.5 7.5 4.142 0 7.5-3.358 7.5-7.5 0-4.142-3.358-7.5-7.5-7.5zm0 2.676c2.664 0 4.824 2.16 4.824 4.824 0 2.664-2.16 4.824-4.824 4.824-2.664 0-4.824-2.16-4.824-4.824 0-2.664 2.16-4.824 4.824-4.824z\" transform=\"translate(-251 -362) translate(36 350) translate(216 13)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/camera-icon.e24235db27591e36001828a120e898e3.svg"),
        {
          React: SvgCameraIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      